import { useState, useEffect } from 'react';

let isFlagEmojiSupported = null;
const useIsFlagEmojiSupported = () => {
    const [isSupported, setIsSupported] = useState(isFlagEmojiSupported ?? true);
    useEffect(() => {
        if (isFlagEmojiSupported !== null) {
            return;
        }
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        if (!context) {
            setIsSupported(false);
            isFlagEmojiSupported = false;
            canvas.remove();
            return;
        }
        context.textBaseline = 'top';
        context.font = '32px Arial';
        context.fillText('🇧🇾', 0, 0);
        const data = context.getImageData(0, 0, 32, 32).data;
        canvas.remove();
        let i = 0;
        while (i < data.length) {
            if (data[i] !== data[i + 1] || data[i] !== data[i + 2]) {
                setIsSupported(true);
                isFlagEmojiSupported = true;
                return;
            }
            i += 4;
        }
        setIsSupported(false);
        isFlagEmojiSupported = false;
    }, [isSupported]);
    return isSupported;
};

export { useIsFlagEmojiSupported };
//# sourceMappingURL=useIsFlagEmojiSupported.js.map
